// extracted by mini-css-extract-plugin
export default {"content":"style_content__CVeu7","checkbox":"style_checkbox__vFham"};